<script setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { StealieHeading } from "@get-overalls/fe-stealie";
import { Squares2X2Icon } from "@heroicons/vue/24/outline";
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";
import ContentPanel from "@/components/ContentPanel.vue";
import * as RequestService from "@/services/RequestService";
import { useRequestSurveyStore } from "@/stores/requestSurvey";
import BeginRequestButton from "@/components/BeginRequestButton.vue";

const route = useRoute();
const requestSurveyStore = useRequestSurveyStore();
const categoryDetails = ref([]);
const categoryId = ref(route.params.categoryId);
RequestService.getCategoryRequests(categoryId.value).then((data) => {
  categoryDetails.value = data;
});

watch(
  () => route.params.categoryId,
  (newVal) => {
    categoryId.value = newVal;
    RequestService.getCategoryRequests(newVal).then((data) => {
      categoryDetails.value = data;
    });
  },
);
</script>

<template>
  <AuthenticatedLayout>
    <ContentPanel data-sr-unmask>
      <header class="mt-4 mb-8 flex items-center justify-between px-2 sm:mt-0">
        <StealieHeading level="2" size="lg" class="flex items-center gap-2.5">
          <button
            class="cursor-pointer"
            @click="requestSurveyStore.openCategoryDrawer('explore')"
          >
            <Squares2X2Icon class="size-6 shrink-0 text-brand-primary-teal-400" />
          </button>
          {{ categoryDetails.name }} Requests
        </StealieHeading>
      </header>
      <ul class="mb-8 grid grid-cols-1 gap-4 px-2 sm:grid-cols-2 xl:grid-cols-3">
        <template v-for="request in categoryDetails.requestSurveys" :key="request.id">
          <li>
            <BeginRequestButton :request="request" :category="categoryDetails" />
          </li>
        </template>
      </ul>
    </ContentPanel>
  </AuthenticatedLayout>
</template>
